export const MeasureInformationHelper = {
    bytesToKB(value: number) {
        return value / 1024;
    },

    bytesToMB(value: number) {
        return value / 1024 / 1024;
    },

    bytesToGB(value: number) {
        return value / 1024 / 1024 / 1024;
    },

    kilobytesToBytes(value: number) {
        return value * 1024;
    },

    megabytesToBytes(value: number) {
        return value * 1024 * 1024;
    },

    gigabytesToBytes(value: number) {
        return value * 1024 * 1024 * 1024;
    },

    gigabytesToMegabytes(value: number) {
        return value * 1024;
    },
};
